import { z } from "zod";
import { paginationSchema } from "./common.js";

export const notificationTypeSchema = z.enum([
  "daily_entry_not_submitted",
  "correction_requested",
  "pay_period_ready_for_review",
  "critical_exception_created",
  "pay_period_approved",
  "pay_period_locked",
  "export_ready",
]);

export const notificationItemSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  userId: z.string().uuid(),
  type: notificationTypeSchema,
  title: z.string(),
  message: z.string(),
  targetUrl: z.string().nullable(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});

export const notificationListQuerySchema = paginationSchema.extend({
  unreadOnly: z
    .enum(["true", "false"])
    .optional()
    .transform((v) => v === "true"),
});

export const notificationIdParamSchema = z.object({
  id: z.string().uuid(),
});

export const unreadCountSchema = z.object({
  count: z.number().int(),
});

export type NotificationItem = z.infer<typeof notificationItemSchema>;
export type NotificationType = z.infer<typeof notificationTypeSchema>;
